export default defineAppConfig({
  title: 'Hello App Config',
  description:
    'This is some content coming from app.config.ts that support HMR, try to update it and see it in action.',
  showButton: false,
})
